<template>
<AdminPanelMegogoList />
</template>

<script>
import AdminPanelMegogoList from '../components/AdminPanelMegogoList.vue'
export default {
    data: () => ({}),
    components: {
        AdminPanelMegogoList
    },
    methods: {},
    mounted() {}
}
</script>
